import React from "react";
import { Typography, ResponsiveImage } from "../../../common";
import MarkdownWrapper from "../../../common/MarkdownWrapper";
import { InformationContent } from "../../../../types/newtypes";

interface InformationPreviewProps {
  content: InformationContent;
  onCompleted?: () => void;
  // eslint-disable-next-line no-unused-vars
  onCardStateChange?: (isCompleted: boolean, canProceed: boolean) => void;
}

const InformationPreview: React.FC<InformationPreviewProps> = ({ content }) => {
  return (
    <div className="w-full">
      <div className="flex flex-col max-lg:items-center gap-8 lg:justify-between 2xl:justify-start lg:gap-20 lg:flex-row">
        {content?.image_uri && (
          <div className="h-auto lg:max-w-[60vh] xl:max-w-[50vw] lg:order-2 order-1">
            <ResponsiveImage
              image_uri={content.image_uri}
              alt={content.alt_text || "Information illustration"}
              // Allow a larger maximum while remaining responsive
              maxWidth="500px"
              maxHeight="600px"
              objectFit="contain"
              containerClassName="rounded-lg"
              placeholderText="Information illustration not available"
            />
          </div>
        )}
        <div className="flex-1 lg:order-1 order-2">
          <Typography
            variant="h4"
            weight="bold"
            className="max-md:!text-xl mb-6"
          >
            {content?.slide_title}
          </Typography>
          <MarkdownWrapper content={content?.text || ""} />
        </div>
      </div>
    </div>
  );
};

export default InformationPreview;
